<kendo-dialog
  class="validation-result-dialog"
  *ngIf="vm.visible"
  title="Validation Results"
  (close)="hide()"
  [minWidth]="700"
  [width]="560"
>
  <ng-container *ngIf="vm.message?.errors?.length; else noMessages">
    <div style="max-height: 400px; overflow-y: auto;">
    <div *ngFor="let e of vm.message!.errors">
      <kendo-card width="100%">
        <kendo-card-header class="k-hstack k-gap-4">
          <div style="width: 80px">
            <button
              kendoButton
              class="m-l-4 badge-button k-pointer-events-none"
              [ngClass]="{
                'error-bg': e.severity == 0,
                'warning-bg': e.severity == 1,
                'info-bg': e.severity == 2,
              }"
              size="small"
              rounded="full"
            >
              <span [ngSwitch]="e.severity">
                <ng-container *ngSwitchCase="0">Error</ng-container>
                <ng-container *ngSwitchCase="1">Warning</ng-container>
                <ng-container *ngSwitchDefault>Info</ng-container>
              </span>
            </button>
          </div>
          <div class="k-hstack k-gap-4">
            <p kendoCardSubtitle>
              {{ e.errorMessage }}
            </p>
            <div *ngIf="e.propertyName || e.entityId">
              <span *ngIf="e.propertyName">{{ e.propertyName }}</span>
              <span *ngIf="e.entityName"> with Item: {{ e.entityName }}</span>
              <span *ngIf="e.entityId"> ({{ e.entityId }})</span>
            </div>
          </div>
        </kendo-card-header>
      </kendo-card>
    </div>
    </div>
  </ng-container>

  <ng-template #noMessages>
    <p>There was a failure, but no details were provided.</p>
  </ng-template>

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="hide()" themeColor="primary">Dismiss</button>
  </kendo-dialog-actions>
</kendo-dialog>
